import {
  RouteConfig
} from 'vue-router'
import Layout from '@/layout/index.vue'


const cmsRouter: RouteConfig = {
  path: '/cms',
  component: Layout,
  redirect: '/cms/list',
  name: '文章管理',
  meta: {
    title: '文章管理'
  },
  children: [
    {
      path: 'categoryList',
      name: 'cmsCategoryList',
      component: () => import(/* webpackChunkName: "cms" */'@/views/cms/categoryList.vue'),
      meta: {
        title: '文章分类'
      }
    },
    {
      path: 'category/create',
      name: 'category-create',
      component: () => import(/* webpackChunkName: "cms" */'@/views/cms/categoryEdit.vue'),
      meta: {
        title: '新建文章分类'
      }
    },
    {
      path: 'category/edit/:id',
      name: 'category-edit',
      component: () => import(/* webpackChunkName: "cms" */'@/views/cms/categoryEdit.vue'),
      meta: {
        title: '编辑文章分类'
      }
    },
    {
      path: 'contentList',
      name: 'cmsContentList',
      component: () => import(/* webpackChunkName: "cms" */ '@/views/cms/cmsContentList.vue'),
      meta: {
        title: '文章列表'
      }
    },
    {
      path: 'createCmsContent',
      name: 'createCmsContent',
      component: () => import(/* webpackChunkName: "cms" */ '@/views/cms/edit-cmsContent.vue'),
      meta: {
        title: '新建'
      }
    },
    {
      path: 'editContent/:id',
      name: 'editCmsContent',
      component: () => import(/* webpackChunkName: "cms" */ '@/views/cms/edit-cmsContent.vue'),
      meta: {
        title: '编辑新闻'
      }
    }
  ]
}

export default cmsRouter
